import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Modal = ({
  title, subtitle, children,
}) => (
  <div className="modal__container">
    <div className="modal">
      {title && (
        <div className="modal__title">
          {title}
        </div>
      )}
      {subtitle && (
        <div className="modal__subtitle">
          {subtitle}
        </div>
      )}
      <div className="modal__content">
        {children}
      </div>
    </div>
  </div>
);

Modal.defaultProps = {
  title: '',
  subtitle: '',
};

Modal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Modal;
